class LoadMoreButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.load-more-button');

    if (this.button) {
      this.button.addEventListener('click', this.loadMore.bind(this));
    }
  }

  loadMore(event) {
    event.preventDefault();

    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    // Show loading state
    const originalText = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = 'Loading...';

    // Fetch the next page
    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find the product grid in the fetched content
        const newProducts = doc.querySelector('#main-collection-product-grid');
        const currentGrid = document.querySelector('#main-collection-product-grid');

        if (newProducts && currentGrid) {
          // Append new products to the current grid
          const products = newProducts.children;
          Array.from(products).forEach(product => {
            currentGrid.appendChild(product);
          });
        }

        // Update or remove the load more button
        const newLoadMoreButton = doc.querySelector('.load-more-button');

        if (newLoadMoreButton) {
          // Update the button with new data attributes
          this.button.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
          this.button.dataset.currentPage = newLoadMoreButton.dataset.currentPage;
          this.button.dataset.totalPages = newLoadMoreButton.dataset.totalPages;

          // Re-enable the button
          this.button.disabled = false;
          this.button.textContent = originalText;
        } else {
          // No more pages, remove the button
          this.remove();
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        this.button.disabled = false;
        this.button.textContent = 'Error loading products. Try again.';
      });
  }
}

customElements.define('load-more-button', LoadMoreButton);
